var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiscellaneousDetailsStepIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#2E77D0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "#CFCFCF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.22857 13.1714L8 12.3429L15.3429 9L22.5429 12.3429L22.2571 12.9429L21.8571 12.7714V21H20.4286V12.7714H10.0857V21H8.65714V12.9429L8.22857 13.1714ZM10.4857 13.2002H20V13.5431H10.4857V13.2002ZM20 13.9139H10.4857V14.2568H20V13.9139ZM10.4857 14.6003H20V14.9432H10.4857V14.6003ZM14.8286 16.172H11.8V18.4863H14.8286V16.172ZM10.2857 18.6858H13.3143V21.0001H10.2857V18.6858ZM16.7429 18.6858H13.7143V21.0001H16.7429V18.6858ZM17.1428 18.6858H20.1714V21.0001H17.1428V18.6858ZM18.2572 16.172H15.2286V18.4863H18.2572V16.172Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscellaneousDetailsStepIcon);
export default __webpack_public_path__ + "static/media/miscellaneous-details-step-icon.9e37dfbff8c3467a765381c2437ab4cb.svg";
export { ForwardRef as ReactComponent };